import React from 'react';
import { Modal, Spin } from 'antd';
import { WifiOff } from 'lucide-react';
import { styles, createModalTitle } from '../ReconnectionModal.styles';

const SoftReconnectionModal = ({ visible }) => {
  return (
    <Modal
      title={createModalTitle('Connection Lost')}
      open={visible}
      closable={false}
      footer={null}
      centered
    >
      <div style={styles.modalContent}>
        <div style={styles.iconContainer}>
          <WifiOff
            size={48}
            style={{ color: '#666' }}
          />
        </div>
        <p style={styles.description}>We're attempting to restore your connection automatically.</p>
        <div style={styles.spinnerContainer}>
          <Spin size="small" />
          <span style={styles.spinnerText}>Reconnecting...</span>
        </div>
      </div>
    </Modal>
  );
};

export default SoftReconnectionModal;
